/// <amd-module name="Test/TestPlansHubRefresh/TestPlansHubRefreshDialogs/RunWithOptionsDialog/RunWithOptionsDialog" />
import { Build } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import * as React from "react";
import * as RMContracts from "Test/Release/Client/Contracts/Release";
import { IReleaseRestClient } from "Test/Release/Client/RestClient/Release";
import { PointsActions } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsActions";
import { ITestPointItem, RunOptions } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsContracts";
import { testHubRefreshLocalContextData } from "Test/TestPlansHubRefresh/TestHub/Utils/TestPlansHubRefreshLocalContextProvider";
import * as Resources from "Test/TestPlansHubRefresh/TestPlansHubRefreshDialogs/RunWithOptionsDialog/Resources";
import { ITestRunsMenu, ITestRunsMenuExtended } from "Test/TestPlansHubRefresh/TestRunsMenu/TestRunsMenu.Types";
import { TestHubRefreshConstants } from "Test/TestPlansHubRefresh/TestHub/Constants";
import * as ExecuteConstants from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/ExecuteConstants";
import { format } from "VSS/Core/Util/String";
import { ITfsPageService } from "Tfs/Platform/Page";
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { getCookie, setCookie } from "VSS/Platform/Util/Cookie";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { Components, IVssLayoutManager, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { CustomDialog } from "VSSUI/Dialog";
import { Dropdown } from "VSSUI/Dropdown";
import { CustomHeader, HeaderTitle, TitleSize } from "VSSUI/Header";
import { IListBoxItem } from "VSSUI/ListBox";
import { Observer } from "VSSUI/Observer";
import { PanelContent, PanelFooter } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";
import { DropdownMultiSelection } from "VSSUI/Utilities/DropdownSelection";

export interface IRunWithOptionsDialogProps {
    params: ITestRunsMenuExtended;
    onDismiss: () => void;
}

class RunWithOptionsDialogState {
    isReleaseDefnLoading: boolean;
    isReleaseStageLoading: boolean;
    isBuildDefnLoading: boolean;
    //disables the run button for automated run type, whenever the release definition or the environment is not selected
    isRunButtonEnabled: boolean;
}

export class RunWithOptionsDialog extends VssComponent<IRunWithOptionsDialogProps, RunWithOptionsDialogState> {
    private selectedBuild: Build = {} as Build;
    private releaseDefinition: RMContracts.ReleaseDefinition | undefined;
    private environmentId: number | undefined;
    private selectedBuildNumber = new ObservableValue<string>("");
    private runOption = RunOptions.RunTestUsingRunWithOptionsWebRunner;
    private testTypeRunnerTestDescription = new ObservableValue<string>(Resources.TestTypeAndRunnerDescription_WebRunner);
    private dataCollectorsArray: string[] = [
        Resources.DataCollectorsOption_ActionLog,
        Resources.DataCollectorsOption_EventLog,
        Resources.DataCollectorsOption_ScreenAndVoiceRecorder,
        Resources.DataCollectorsOption_SystemInformation
    ];
    private dataCollectorsSelected: string[] = [];
    private dataCollectorsSelection = new DropdownMultiSelection();
    private _releasePipelineDropdownItems: ObservableArray<IListBoxItem<{}>> = new ObservableArray<IListBoxItem<{}>>();
    private _stageDropdownItems: ObservableArray<IListBoxItem<{}>> = new ObservableArray<IListBoxItem<{}>>();
    private releaseDefinitionPlaceHolder: string = Resources.SelectFromList;
    private stagePlaceHolder: string = Resources.SelectFromList;

    constructor(props: IRunWithOptionsDialogProps) {
        super(props);
        this.state = {
            isBuildDefnLoading: Number(props.params.selectedBuildDefnId) ? true : false,
            isReleaseDefnLoading: props.params.selectedReleaseId ? true : false,
            isReleaseStageLoading: props.params.selectedReleaseEnvironmentId ? true : false,
            isRunButtonEnabled: true
        };
        this.toggleRunButton = this.toggleRunButton.bind(this);
    }

    public toggleRunButton() {
        if (!this.state.isRunButtonEnabled && ((this.releaseDefinition && this.environmentId) || this.runOption != RunOptions.AutomatedTestRun)) {
            this.setState({ isRunButtonEnabled: true });
        } else if (
            this.state.isRunButtonEnabled &&
            this.runOption == RunOptions.AutomatedTestRun &&
            (!this.releaseDefinition || !this.environmentId)
        ) {
            this.setState({ isRunButtonEnabled: false });
        }
    }

    public onReleaseDefnLoaded() {
        this.setState({ isReleaseDefnLoading: false });
    }
    public onReleaseEnvironmentDefnLoaded() {
        this.setState({ isReleaseStageLoading: false });
    }
    public onBuildDefnLoaded() {
        this.setState({ isBuildDefnLoading: false });
    }

    public render(): JSX.Element {
        return (
            <CustomDialog calloutContentClassName="run-with-options-dialog-callout-element" className="testplanshubrefresh-run-with-options-dialog v-scroll-auto custom-scrollbar" onDismiss={this.props.onDismiss} modal={true}>
                <CustomHeader className="hubrefresh-bolt-header-with-commandbar">
                    <HeaderTitle titleSize={TitleSize.Large}>{Resources.RunWithOptionsTitle}</HeaderTitle>
                </CustomHeader>
                <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-top-padding">
                    {Resources.TestTypeAndRunnerSelectionText}
                </PanelContent>
                <PanelContent className="body-m">
                    <Dropdown
                        className="body-m flex-grow run-with-options-dialog-bottom-padding test-type-and-runner-dropdown"
                        placeholder={Resources.TestTypeAndRunnerOption_WebRunner}
                        items={this._getTestTypeAndRunnerDropdownItems()}
                        onSelect={(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<{}>) => this._updateTestTypeAndRunner(item.id)}
                        ariaLabel={Resources.TestTypeAndRunnerSelectionText}
                    />
                </PanelContent>
                <Observer testTypeRunnerTestDescription={this.testTypeRunnerTestDescription}>
                    {(props: { testTypeRunnerTestDescription: string }) => {
                        return (
                            <div className="run-with-options-dialog-description-wrapper">
                                <PanelContent className="body-m run-with-options-dialog-min-height">{props.testTypeRunnerTestDescription}</PanelContent>
                                {this._getPanelToRender()}
                            </div>
                        );
                    }}
                </Observer>
                <PanelFooter className="body-m">
                    <Button
                        primary={true}
                        className="run-with-options-dialog-footer-button"
                        disabled={!this.state.isRunButtonEnabled}
                        text={Resources.Run}
                        onClick={() => {
                            const selectedtestPoints: ITestPointItem[] = [];
                            const selectionLength = this.props.params.selection.value.length;

                            for (let i = 0; i < selectionLength; i++) {
                                let beginIndex = this.props.params.selection.value[i].beginIndex;
                                let endIndex = this.props.params.selection.value[i].endIndex;

                                for (let j = beginIndex; j <= endIndex; j++) {
                                    selectedtestPoints.push(this.props.params.points[j]);
                                }
                            }

                            // Getting the selected data collectors.
                            for (let i = 0; i < this.dataCollectorsSelection.value.length; i++) {
                                let beginIndex = this.dataCollectorsSelection.value[i].beginIndex;
                                let endIndex = this.dataCollectorsSelection.value[i].endIndex;

                                for (let j = beginIndex; j <= endIndex; j++) {
                                    this.dataCollectorsSelected.push(this.dataCollectorsArray[j]);
                                }
                            }

                            if (selectedtestPoints.length > 0) {
                                const runParams: ITestRunsMenu = {
                                    planAreaPath: this.props.params.planAreaPath,
                                    planId: this.props.params.planId,
                                    planIteration: this.props.params.planIteration,
                                    planName: this.props.params.planName,
                                    points: selectedtestPoints,
                                    suiteId: this.props.params.suiteId,
                                    suiteName: this.props.params.suiteName,
                                    runOptions: this.runOption,
                                    dataCollectors: this.dataCollectorsSelected,
                                    selectedBuild: this.selectedBuild,
                                    releaseDefinition: this.releaseDefinition,
                                    environmentId: this.environmentId
                                };

                                /**
                                 * Point Ids which are invoked in web runner are stored in local context
                                 * this is done to refresh points in UI when web runner is closed.
                                 */

                                // Removing undefined/null entries from the array no avoid null refs.
                                let filteredSelectedTestPoints = selectedtestPoints.filter((point) => {
                                    return point != null && point != undefined;
                                });

                                const testPointIds = filteredSelectedTestPoints.map((points) => points.id);
                                testHubRefreshLocalContextData.setWebRunnerPointIds(testPointIds);

                                if (this.runOption === RunOptions.RunTestUsingRunWithOptionsWebRunner) {
                                    this.props.params.dispatch(PointsActions.openTestPointsRunnerClient(runParams));
                                } else if (this.runOption === RunOptions.RunTestUsingTestRunner) {
                                    this.props.params.dispatch(PointsActions.openApplicationTestRunner(runParams));
                                } else if (this.runOption === RunOptions.RunTestUsingNewMTM) {
                                    this.props.params.dispatch(PointsActions.openTestPointsRunnerClient(runParams));
                                } else if (this.runOption === RunOptions.RunTestUsingOldMTM) {
                                    this.props.params.dispatch(PointsActions.openTestPointsRunnerClient(runParams));
                                } else if (this.runOption === RunOptions.AutomatedTestRun) {
                                    this.props.params.dispatch(PointsActions.openTestPointsRunnerClient(runParams));
                                }
                            } else {
                                alert(Resources.NoItemSelected);
                            }

                            // To close the dialog when someone clicks on Run button.
                            this.props.onDismiss();
                        }}
                    />
                </PanelFooter>
            </CustomDialog>
        );
    }

    // **isBuildDefinitionChanged: undefined for the initial load of the dialog to ensure that test plan default settings are loaded
    private _populateReleaseDefinitionList(project: any, isBuildDefinitionChanged?: boolean): void {
        if (project && project.name && project.id) {
            const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
            contributionService.getContributionAsync("ms.vss-test-web.release-client").then(() => {
                let artifactSourceId = "";
                artifactSourceId = `${project.id}:${this.selectedBuild.definition.id}`;
                let release = this.context.pageContext.getRestClient<IReleaseRestClient>("Release_4.1.IReleaseRestClient");
                let releaseDefinitions = release.getReleaseDefinitions(
                    project.name,
                    undefined,
                    undefined,
                    "Build",
                    artifactSourceId,
                    undefined,
                    undefined,
                    RMContracts.ReleaseDefinitionQueryOrder.NameAscending
                );
                releaseDefinitions.then((releaseDefinition) => {
                    if (releaseDefinition) {
                        this._releasePipelineDropdownItems.removeAll();
                        this._stageDropdownItems.removeAll();
                        for (let i = 0; i < releaseDefinition.length; i++) {
                            if (releaseDefinition[i]) {
                                this._releasePipelineDropdownItems.push({
                                    id: releaseDefinition[i].id.toString(),
                                    text: releaseDefinition[i].name,
                                    data: releaseDefinition[i]
                                });
                            }
                        }
                        //clear all the dropdowns and placeholders in case of change in build definition
                        if (isBuildDefinitionChanged) {
                            this.releaseDefinitionPlaceHolder = Resources.SelectFromList;
                            this.stagePlaceHolder = Resources.SelectFromList;
                            this.releaseDefinition = undefined;
                            this.environmentId = undefined;
                            this.toggleRunButton();
                            this.onReleaseDefnLoaded();
                            this.onReleaseEnvironmentDefnLoaded();
                        }
                    }
                });
            });
        }
    }

    private _populateBuildDefinition(project: any): void {
        if (project && project.name) {
            const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
            contributionService.getContributionAsync("ms.vss-build-web.common-client").then(() => {
                const buildClient = this.context.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
                if (Number(this.props.params.selectedBuildId)) {
                    const testPlanBuild = buildClient.getBuild(project.name, Number(this.props.params.selectedBuildId));
                    testPlanBuild.then((testPlanBuild) => {
                        this.selectedBuild = testPlanBuild;
                        this.selectedBuildNumber.value = testPlanBuild.buildNumber;
                        this.onBuildDefnLoaded();
                        //update the release definition dropdown list
                        this._populateReleaseDefinitionList(project);
                    });
                } else {
                    const testPlanBuild = buildClient.getLatestBuild(project.name, String(this.props.params.selectedBuildDefnId));
                    testPlanBuild.then(
                        (testPlanBuild) => {
                            this.selectedBuild = testPlanBuild;
                            this.selectedBuildNumber.value = testPlanBuild.buildNumber;
                            this.onBuildDefnLoaded();
                            //update the release definition dropdown list
                            this._populateReleaseDefinitionList(project);
                        },
                        (reason: any) => {
                            this.onBuildDefnLoaded();
                        }
                    );
                }
            });
        }
    }

    private _getPanelToRender(): JSX.Element {
        const pageService = this.context.pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = pageService.getData();
        if (this.runOption === RunOptions.RunTestUsingRunWithOptionsWebRunner) {
            if (this.state.isBuildDefnLoading && Number(this.props.params.selectedBuildDefnId)) {
                this._populateBuildDefinition(pageData ? pageData.project : null);
            }
            return (
                <div>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-top-padding">
                        {Resources.Build}
                    </PanelContent>
                    <PanelContent className="body-m run-with-options-dialog-bottom-padding">
                        <div className="body-m flex-grow run-with-options-dialog-right-padding scroll-hidden">
                            <TextField
                                required={false}
                                disabled={true}
                                rows={1}
                                value={this.state.isBuildDefnLoading ? Resources.LoadingIndication : this.selectedBuildNumber}
                                ariaLabel={Resources.Build}
                            />
                        </div>
                        <Button
                            className="run-with-options-dialog-button-height"
                            iconProps={{
                                iconName: "More"
                            }}
                            ariaLabel={Resources.FindBuilds}
                            onClick={() => {
                                const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                                const findBuildsDialogProxyProps = {
                                    okCallback: (build: Build) => {
                                        this.selectedBuild = build;
                                        if (build) {
                                            this.selectedBuildNumber.value = build.buildNumber;
                                        }
                                        this._populateReleaseDefinitionList(pageData ? pageData.project : null, true);
                                    }
                                };

                                layoutManager.renderCallout((onDismiss) => {
                                    return React.createElement(LegacyComponent, {
                                        modules: ["TestManagement/Scripts/Shared/FindBuildsDialogProxy"],
                                        wrappedType: "find-builds-dialog-proxy",
                                        wrappedProps: findBuildsDialogProxyProps
                                    });
                                });
                            }}
                        />
                    </PanelContent>
                    <PanelContent className="body-m">{Resources.BuildDescription}</PanelContent>
                </div>
            );
        } else if (this.runOption === RunOptions.RunTestUsingTestRunner) {
            if (isFeatureFlagEnabled(this.context.pageContext, TestHubRefreshConstants.ShowDTRUpdateMsgLaunchDialog, false)) {
                // hideDTRLaunchDialogCookieState is a popup state of the launch dialog.
                // "true" then this means pop up is hidden.
                // "" means cookie is not created/deleted. this state will display the launch popup.       
                const hideDTRLaunchDialogCookieState = getCookie(ExecuteConstants.HideDTRLaunchDialogCookieName);
                if (hideDTRLaunchDialogCookieState === "true" || hideDTRLaunchDialogCookieState === "") {
                     //sets the cookie value to show the launch DTR dialog
                    setCookie(ExecuteConstants.HideDTRLaunchDialogCookieName, "falseAlways");
                    const showVersionUpdateMessage = getCookie(ExecuteConstants.ShowDTRVersionUpdateMessageCookieName);
                    if (showVersionUpdateMessage === "") {
                        let date = new Date();
                        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
                        //setting the cookie expire in 7 days
                        const expires = "; expires=" + date.toUTCString();
                        //create a cookie to maintain the state of new version for update message.
                        setCookie(ExecuteConstants.ShowDTRVersionUpdateMessageCookieName, "true", "/ ;" + expires);
                    }
                }
            }

            return (
                <div>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-top-padding">
                        {Resources.DownloadTestRunner}
                    </PanelContent>
                    <PanelContent>{Resources.DownloadTestRunnerDescription}</PanelContent>
                    <PanelContent className="run-with-options-dialog-min-height">
                        <a href="https://aka.ms/ATPTestRunnerDownload">{Resources.GetItNow}</a>
                    </PanelContent>
                    {isFeatureFlagEnabled(this.context.pageContext, TestHubRefreshConstants.ShowDTRUpdateMsgLaunchDialog, false) &&
                    getCookie(ExecuteConstants.ShowDTRVersionUpdateMessageCookieName) === "true" ? (
                        <PanelContent className="run-with-options-dialog-min-height-newatrversion">
                            <p>
                                <mark>
                                    <b>{Resources.NewATRVersionTextPrefix}</b>
                                    {format(Resources.NewATRVersionText, Resources.LatestATRVersion)}
                                </mark>
                            </p>
                        </PanelContent>
                    ) : null}
                    <PanelContent className="run-with-options-dialog-min-height">
                        <a href="https://aka.ms/ATPTestRunnerLearnMore" target="_blank">
                            {Resources.LearnMore}
                        </a>
                    </PanelContent>
                </div>
            );
        } else if (this.runOption === RunOptions.AutomatedTestRun) {
            const pageService = this.context.pageContext.getService<ITfsPageService>("ITfsPageService");
            const pageData = pageService.getData();
            if (pageData && pageData.project) {
                const projectName: string = pageData.project.name;
                const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
                if (Number(this.props.params.selectedBuildDefnId) && this.state.isBuildDefnLoading) {
                    this._populateBuildDefinition(pageData ? pageData.project : null);
                }
                if (this.props.params.selectedReleaseId && this.state.isReleaseDefnLoading) {
                    contributionService.getContributionAsync("ms.vss-test-web.release-client").then(() => {
                        const releaseClient = this.context.pageContext.getRestClient<IReleaseRestClient>("Release_4.1.IReleaseRestClient");
                        const testPlanRelease = releaseClient.getReleaseDefinition(projectName, this.props.params.selectedReleaseId!);
                        testPlanRelease.then((testPlanRelease) => {
                            this.releaseDefinition = testPlanRelease;
                            this.releaseDefinitionPlaceHolder = testPlanRelease.name;
                            this.onReleaseDefnLoaded();

                            //update stage list
                            this._stageDropdownItems.removeAll();

                            if (this.releaseDefinition.environments) {
                                for (let j = 0; j < this.releaseDefinition.environments.length; j++) {
                                    this._stageDropdownItems.push({
                                        id: this.releaseDefinition.environments[j].id.toString(),
                                        text: this.releaseDefinition.environments[j].name
                                    });
                                    //populate stage placeholder as per test plan settings
                                    if (this.props.params.selectedReleaseEnvironmentId === this.releaseDefinition.environments[j].id) {
                                        this.stagePlaceHolder = this.releaseDefinition.environments[j].name;
                                        this.environmentId = this.props.params.selectedReleaseEnvironmentId;
                                        this.toggleRunButton(); //enables the run button as soon as the test plan default settings are loaded
                                        this.onReleaseEnvironmentDefnLoaded();
                                    }
                                }
                            }
                        });
                    });
                }
            }

            return (
                <div>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-top-padding">
                        {Resources.Build}
                    </PanelContent>
                    <PanelContent className="body-m run-with-options-dialog-bottom-padding">
                        <div className="body-m flex-grow run-with-options-dialog-right-padding scroll-hidden">
                            <TextField
                                required={false}
                                disabled={true}
                                rows={1}
                                value={this.state.isBuildDefnLoading ? Resources.LoadingIndication : this.selectedBuildNumber}
                            />
                        </div>
                        <Button
                            className="run-with-options-dialog-button-height"
                            iconProps={{
                                iconName: "More"
                            }}
                            ariaLabel={Resources.FindBuilds}
                            onClick={() => {
                                const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                                const findBuildsDialogProxyProps = {
                                    okCallback: (build: Build) => {
                                        this.selectedBuild = build;
                                        if (build) {
                                            this.selectedBuildNumber.value = build.buildNumber;
                                        }
                                        this._populateReleaseDefinitionList(pageData ? pageData.project : null, true);
                                    }
                                };
                                layoutManager.renderCallout((onDismiss) => {
                                    return React.createElement(LegacyComponent, {
                                        modules: ["TestManagement/Scripts/Shared/FindBuildsDialogProxy"],
                                        wrappedType: "find-builds-dialog-proxy",
                                        wrappedProps: findBuildsDialogProxyProps
                                    });
                                });
                            }}
                        />
                    </PanelContent>
                    <PanelContent className="body-m">{Resources.BuildDescription}</PanelContent>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-min-height">
                        {Resources.EnvironmentToRunAutomatedTests}
                    </PanelContent>
                    <PanelContent className="body-m run-with-options-dialog-bottom-padding">{Resources.EnivronmentDescription}</PanelContent>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-min-height">
                        {Resources.ReleasePipeline}
                    </PanelContent>
                    <PanelContent className="body-m">
                        <Dropdown
                            className="body-m flex-grow run-with-options-dialog-bottom-padding"
                            items={this._releasePipelineDropdownItems}
                            placeholder={this.state.isReleaseDefnLoading ? Resources.LoadingIndication : this.releaseDefinitionPlaceHolder}
                            onSelect={(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<{}>) => {
                                this.releaseDefinition = item.data as RMContracts.ReleaseDefinition;

                                // Emptying the items in stage dropdown.
                                this._stageDropdownItems.removeAll();
                                this.stagePlaceHolder = Resources.SelectFromList;
                                this.environmentId = undefined;

                                if (this.releaseDefinition.environments) {
                                    for (let j = 0; j < this.releaseDefinition.environments.length; j++) {
                                        this._stageDropdownItems.push({
                                            id: this.releaseDefinition.environments[j].id.toString(),
                                            text: this.releaseDefinition.environments[j].name
                                        });
                                    }
                                }
                                this.toggleRunButton();
                            }}
                        />
                    </PanelContent>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-min-height">
                        {Resources.Stage}
                    </PanelContent>
                    <PanelContent className="body-m">
                        <Dropdown
                            className="body-m flex-grow run-with-options-dialog-bottom-padding"
                            items={this._stageDropdownItems}
                            placeholder={this.state.isReleaseStageLoading ? Resources.LoadingIndication : this.stagePlaceHolder}
                            onSelect={(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<{}>) => {
                                this.environmentId = Number(item.id);
                                this.toggleRunButton();
                            }}
                        />
                    </PanelContent>
                </div>
            );
        } else if (this.runOption === RunOptions.RunTestUsingNewMTM) {
            if (this.props.params.selectedBuildDefnId && this.state.isBuildDefnLoading) {
                this._populateBuildDefinition(pageData ? pageData.project : null);
            }
            return (
                <div>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-top-padding">
                        {Resources.Build}
                    </PanelContent>
                    <PanelContent className="body-m run-with-options-dialog-bottom-padding">
                        <div className="body-m flex-grow run-with-options-dialog-right-padding scroll-hidden">
                            <TextField required={false} disabled={true} rows={1} value={this.selectedBuildNumber} />
                        </div>
                        <Button
                            className="run-with-options-dialog-button-height"
                            iconProps={{
                                iconName: "More"
                            }}
                            ariaLabel={Resources.FindBuilds}
                            onClick={() => {
                                const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                                const findBuildsDialogProxyProps = {
                                    okCallback: (build: Build) => {
                                        this.selectedBuild = build;
                                        if (build) {
                                            this.selectedBuildNumber.value = build.buildNumber;
                                        }
                                        this._populateReleaseDefinitionList(pageData ? pageData.project : null, true);
                                    }
                                };
                                layoutManager.renderCallout((onDismiss) => {
                                    return React.createElement(LegacyComponent, {
                                        modules: ["TestManagement/Scripts/Shared/FindBuildsDialogProxy"],
                                        wrappedType: "find-builds-dialog-proxy",
                                        wrappedProps: findBuildsDialogProxyProps
                                    });
                                });
                            }}
                        />
                    </PanelContent>
                    <PanelContent className="body-m">{Resources.BuildDescription}</PanelContent>
                    <PanelContent className="body-m font-weight-semibold run-with-options-dialog-bottom-padding run-with-options-dialog-min-height">
                        {Resources.DataCollectors}
                    </PanelContent>
                    <PanelContent className="body-m">
                        <Observer selection={this.dataCollectorsSelection}>
                            {() => {
                                return (
                                    <Dropdown
                                        actions={[
                                            {
                                                className: "bolt-dropdown-action-right-button",
                                                disabled: this.dataCollectorsSelection.selectedCount === 0,
                                                iconProps: { iconName: "Clear" },
                                                text: Resources.Clear,
                                                onClick: () => {
                                                    this.dataCollectorsSelection.clear();
                                                }
                                            }
                                        ]}
                                        className="body-m flex-grow run-with-options-dialog-bottom-padding"
                                        items={this._getDataCollectorsDropdownItems()}
                                        selection={this.dataCollectorsSelection}
                                        placeholder={Resources.SelectFromList}
                                        showFilterBox={true}
                                    />
                                );
                            }}
                        </Observer>
                    </PanelContent>
                    <PanelContent className="body-m">{Resources.DataCollectorsDescription}</PanelContent>
                    <PanelContent>
                        <a href="https://aka.ms/mtr2016" target="_blank">
                            {Resources.LearnMore}
                        </a>
                    </PanelContent>
                </div>
            );
        } else {
            return <div />;
        }
    }

    private _getTestTypeAndRunnerDropdownItems(): ObservableArray<IListBoxItem<{}>> {
        let _items = new ObservableArray<IListBoxItem<{}>>();
        _items.push({ id: RunOptions.RunTestUsingRunWithOptionsWebRunner.toString(), text: Resources.TestTypeAndRunnerOption_WebRunner });
        _items.push({ id: RunOptions.RunTestUsingTestRunner.toString(), text: Resources.TestTypeAndRunnerOption_TestRunner });
        _items.push({ id: RunOptions.AutomatedTestRun.toString(), text: Resources.TestTypeAndRunnerOption_AutomatedTests });
        _items.push({ id: RunOptions.RunTestUsingNewMTM.toString(), text: Resources.TestTypeAndRunnerOption_MTM2017 });
        _items.push({ id: RunOptions.RunTestUsingOldMTM.toString(), text: Resources.TestTypeAndRunnerOption_MTM2015 });
        return _items;
    }

    private _getDataCollectorsDropdownItems(): ObservableArray<IListBoxItem<{}>> {
        let _items = new ObservableArray<IListBoxItem<{}>>();
        _items.push({ id: Resources.DataCollectorsOption_ActionLog, text: Resources.DataCollectorsOption_ActionLog });
        _items.push({ id: Resources.DataCollectorsOption_EventLog, text: Resources.DataCollectorsOption_EventLog });
        _items.push({ id: Resources.DataCollectorsOption_ScreenAndVoiceRecorder, text: Resources.DataCollectorsOption_ScreenAndVoiceRecorder });
        _items.push({ id: Resources.DataCollectorsOption_SystemInformation, text: Resources.DataCollectorsOption_SystemInformation });
        return _items;
    }

    public _updateTestTypeAndRunner(id: string) {
        if (id === RunOptions.RunTestUsingRunWithOptionsWebRunner.toString()) {
            this.testTypeRunnerTestDescription.value = Resources.TestTypeAndRunnerDescription_WebRunner;
            this.runOption = RunOptions.RunTestUsingRunWithOptionsWebRunner;
        } else if (id === RunOptions.RunTestUsingTestRunner.toString()) {
            this.testTypeRunnerTestDescription.value = Resources.TestTypeAndRunnerDescription_TestRunner;
            this.runOption = RunOptions.RunTestUsingTestRunner;
        } else if (id === RunOptions.AutomatedTestRun.toString()) {
            this.testTypeRunnerTestDescription.value = Resources.TestTypeAndRunnerDescription_AutomatedTests;
            this.runOption = RunOptions.AutomatedTestRun;
        } else if (id === RunOptions.RunTestUsingNewMTM.toString()) {
            this.testTypeRunnerTestDescription.value = Resources.TestTypeAndRunnerDescription_MTM2017;
            this.runOption = RunOptions.RunTestUsingNewMTM;
        } else if (id === RunOptions.RunTestUsingOldMTM.toString()) {
            this.testTypeRunnerTestDescription.value = Resources.TestTypeAndRunnerDescription_MTM2015;
            this.runOption = RunOptions.RunTestUsingOldMTM;
        }
        //toggle the run button when runner type is changed
        //so that run button is enabled for other runners
        //if it was disabled for automated runner and is disabled
        //for automated runner if it was enabled for other runners
        this.toggleRunButton();
    }
}

Components.add("RunWithOptionsDialog", RunWithOptionsDialog);
